import React, { useContext, useMemo } from 'react';
import formatCurrent from '../../Utils/formatCurrent';
import { ContainerDiscountTextAdvancedPayment } from './styles';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';
import verificaSeParcelaAtrasada from '../../Utils/checkIfBillIsLate';

const DiscountTextAdvancedPayment = ({ parcelas, hide }) => {
  const { tema } = useContext(ContextoListaApartamentos);

  const isParcelaAtrasada = verificaSeParcelaAtrasada(
    parcelas[0]?.parcela?.dataVencimento ?? parcelas[0].dataVencimento
  );

  const values = useMemo(() => {
    let totalValorRejustadoNaoAntecipado = 0;
    let totalValorAntecipado = 0;

    for (const {
      parcela: { valorReajustado, valorReajustadoNaoAntecipado },
      valorReaj,
    } of parcelas) {
      totalValorRejustadoNaoAntecipado += valorReajustadoNaoAntecipado;
      totalValorAntecipado += valorReaj ?? valorReajustado;
    }

    const totalDesconto =
      totalValorRejustadoNaoAntecipado - totalValorAntecipado;

    return {
      totalValorRejustadoNaoAntecipado,
      totalValorAntecipado,
      totalDesconto,
    };
  }, [parcelas]);

  const isHide = hide || isParcelaAtrasada || !values.totalDesconto;
  return (
    <ContainerDiscountTextAdvancedPayment tema={tema}>
      {!isHide && (
        <p className='textoInformativoDesconto'>
          * Você iria pagar{' '}
          <span className='valorSemAntecipacao'>
            {formatCurrent(values.totalValorRejustadoNaoAntecipado)}{' '}
          </span>
          na data de vencimento, com o pagamento antecipado você vai pagar{' '}
          <span className='valorAntecipado'>
            {formatCurrent(values.totalValorAntecipado)}{' '}
          </span>
          com isso você está tendo um desconto estimado de{' '}
          <span className='valorAntecipado'>
            {formatCurrent(values.totalDesconto)}
          </span>
          .
        </p>
      )}
    </ContainerDiscountTextAdvancedPayment>
  );
};

export default DiscountTextAdvancedPayment;
